var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin || _vm.checkAccess('client-summary'))?_c('div',[_c('report-list-page',{attrs:{"page-title":"Client Summary Report","page-icon":"mdi-chart-timeline","descending":true,"headers":_vm.headers,"state-end-point":"clientSummary.clientSummaries","actions":_vm.actions,"show-component":_vm.showComponent,"sort":"email"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }